export const emptyGeoJSONFeature: GeoJSON.Feature<GeoJSON.Point> = {
  type: 'Feature',
  properties: null,
  geometry: { type: 'Point', coordinates: [] }
};
